import { Routes } from '@angular/router';

import { CamRoutes } from '@camelot/menu';
import { FeatureGuard } from '@camelot/user';

export enum EValidationsRoute {
  validations = 'validations',
  workflow = 'workflow',
  myDecision = 'myDecision',
  waitingOthers = 'waitingOthers',
  allPending = 'allPending',
  processed = 'processed',
  dashboard = 'dashboard',
  view = 'view',
}

// À typer `Permission` dès que @camelot/user est publié avec le domaine `validation`.
export const validationsAllPendingPermission = 'manage:validation';

CamRoutes.addRoute({
  key: EValidationsRoute.validations,
  url: 'validations',
  children: [
    {
      key: EValidationsRoute.workflow,
      url: 'workflow/:type',
      children: [
        {
          key: EValidationsRoute.myDecision,
          url: 'my-decision',
        },
        {
          key: EValidationsRoute.waitingOthers,
          url: 'waiting-others',
        },
        {
          key: EValidationsRoute.allPending,
          url: 'all-pending',
        },
        {
          key: EValidationsRoute.processed,
          url: 'processed',
        },
      ],
    },
    {
      key: EValidationsRoute.dashboard,
      url: 'dashboard',
    },
    {
      key: EValidationsRoute.view,
      url: 'view/:id',
    },
  ],
});

export const validationsRoutes: Routes = [
  {
    path: '',
    redirectTo: CamRoutes.getUrl([EValidationsRoute.validations, EValidationsRoute.dashboard]),
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: () => import('./pages/validations-tasks.component').then(c => c.ValidationsTasksPage),
    children: [
      {
        path: CamRoutes.getUrl([EValidationsRoute.validations, EValidationsRoute.workflow]),
        loadComponent: () =>
          import('./pages/workflow/validations-workflow.component').then(c => c.ValidationsWorkflowPage),
        children: [
          {
            path: '',
            redirectTo: CamRoutes.getUrl([
              EValidationsRoute.validations,
              EValidationsRoute.workflow,
              EValidationsRoute.myDecision,
            ]),
            pathMatch: 'full',
          },
          {
            path: CamRoutes.getUrl([
              EValidationsRoute.validations,
              EValidationsRoute.workflow,
              EValidationsRoute.myDecision,
            ]),
            loadComponent: () =>
              import('./pages/my-decision/validations-my-decision.component').then(c => c.ValidationsMyDecisionPage),
          },
          {
            path: CamRoutes.getUrl([
              EValidationsRoute.validations,
              EValidationsRoute.workflow,
              EValidationsRoute.waitingOthers,
            ]),
            loadComponent: () =>
              import('./pages/waiting-others/validations-waiting-others.component').then(
                c => c.ValidationsWaitingOthersPage
              ),
          },
          {
            canActivate: [FeatureGuard],
            data: { permissions: [validationsAllPendingPermission] },
            loadComponent: () =>
              import('./pages/all-pending/validations-all-pending.component').then(c => c.ValidationsAllPendingPage),
            path: CamRoutes.getUrl([
              EValidationsRoute.validations,
              EValidationsRoute.workflow,
              EValidationsRoute.allPending,
            ]),
          },
          {
            path: CamRoutes.getUrl([
              EValidationsRoute.validations,
              EValidationsRoute.workflow,
              EValidationsRoute.processed,
            ]),
            loadComponent: () =>
              import('./pages/processed/validations-processed.component').then(c => c.ValidationsProcessedPage),
          },
        ],
      },
      {
        path: CamRoutes.getUrl([EValidationsRoute.validations, EValidationsRoute.dashboard]),
        loadComponent: () =>
          import('./pages/dashboard/validations-dashboard.component').then(c => c.ValidationsDashboardPage),
      },
    ],
  },
  {
    path: CamRoutes.getUrl([EValidationsRoute.validations, EValidationsRoute.view]),
    loadComponent: () => import('./pages/view/validations-view.component').then(c => c.ValidationsViewPage),
  },
];
